import { Typography } from "@mui/material";

export const reCaptchaMandatoryMessage = () => {
  return (
    <>
      <Typography sx={{ fontSize: "10px", color: "#b3b1b1" }}>
        This site is protected by reCAPTCHA and the Google&nbsp;
        <a href="https://policies.google.com/privacy" target="_blank">
          Privacy Policy
        </a>
        &nbsp;and&nbsp;
        <a href="https://policies.google.com/terms" target="_blank">
          Terms of Services
        </a>
        &nbsp;apply.
      </Typography>
    </>
  );
};
